import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostTagsLinkRequest = {
	sonarObjectTagId: number;
	sonarObjectIds: Array<number>;
};

export const postTagLink = createPostEndpoint<PostTagsLinkRequest>('/api/v3/core/tags/link');
